export default __webpack_public_path__ + "static/sol-42e2243ce8e70c46bcc81ba15400a01a.png";